module.exports = __webpack_public_path__ + "static/media/dashboard-paper.d6572e96.svg";